import Typography from "@mui/material/Typography";
import React from "react";
import { colors } from "src/config/colors";
import { StyledSx } from "src/types/StyledSx";
import { SxProps, Theme } from "@mui/system";
import { Tooltip } from "@mui/material";

interface PriceProps {
  value: number | string;
  variant?: "discount" | "danger" | "default";
  size?: "large" | "medium" | "small";
  isWithoutFromLabel?: boolean;
  sx?: SxProps<Theme>;
  tooltipTitle?: string;
}

const calculateClass = (variant: PriceProps["variant"], styled: StyledSx) => {
  if (variant === "discount") return styled.discount;

  if (variant === "danger") return styled.danger;

  return styled.default;
};

const calculateSize = (size: PriceProps["size"]) => {
  if (size === "small") return "14px";

  if (size === "large") return "16px";

  return "15px";
};

const Price: React.FC<PriceProps> = ({
  value,
  variant,
  size,
  isWithoutFromLabel,
  sx,
  tooltipTitle,
}) => {
  const styled: StyledSx = {
    default: {
      fontSize: calculateSize(size),
      fontWeight: "bold",
      color: colors.blue,
      lineHeight: "normal",
      width: "max-content",
    },
    danger: {
      fontWeight: 550,
      fontSize: calculateSize(size),
      textAlign: "right",
      color: colors.red,
      lineHeight: "normal",
      width: "max-content",
    },
    discount: {
      fontWeight: "normal",
      fontSize: calculateSize(size),
      lineHeight: "17px",
      textDecorationLine: "line-through",
      color: colors.darkGray,
      width: "max-content",
    },
  };

  const priceTypography = () => (
    <Typography
      component="span"
      sx={{ ...(sx ? sx : {}), ...calculateClass(variant, styled) }}
    >
      {isWithoutFromLabel ? "" : "за "}
      {value} ₽
    </Typography>
  );

  return tooltipTitle ? (
    <Tooltip disableFocusListener arrow title={tooltipTitle}>
      {priceTypography()}
    </Tooltip>
  ) : (
    priceTypography()
  );
};

export default Price;
